var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.75C12.5711 13.75 14.25 12.0711 14.25 10C14.25 7.92893 12.5711 6.25 10.5 6.25C8.42893 6.25 6.75 7.92893 6.75 10C6.75 12.0711 8.42893 13.75 10.5 13.75Z",
    stroke: "white",
    strokeWidth: 1.12028,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8516 5.08594C15.0495 5.26823 15.237 5.45573 15.4141 5.64844L17.5469 5.95313C17.8944 6.55665 18.1622 7.20265 18.3438 7.875L17.0469 9.60156C17.0469 9.60156 17.0703 10.1328 17.0469 10.3984L18.3438 12.125C18.1631 12.7976 17.8952 13.4437 17.5469 14.0469L15.4141 14.3516C15.4141 14.3516 15.0469 14.7344 14.8516 14.9141L14.5469 17.0469C13.9434 17.3944 13.2974 17.6622 12.625 17.8438L10.8984 16.5469C10.6333 16.5703 10.3667 16.5703 10.1016 16.5469L8.375 17.8438C7.70236 17.6631 7.05625 17.3952 6.45313 17.0469L6.14844 14.9141C5.95573 14.7318 5.76823 14.5443 5.58594 14.3516L3.45312 14.0469C3.10561 13.4434 2.83776 12.7974 2.65625 12.125L3.95313 10.3984C3.95313 10.3984 3.92969 9.86719 3.95313 9.60156L2.65625 7.875C2.83692 7.20236 3.10481 6.55625 3.45312 5.95313L5.58594 5.64844C5.76823 5.45573 5.95573 5.26823 6.14844 5.08594L6.45313 2.95312C7.05665 2.60561 7.70265 2.33776 8.375 2.15625L10.1016 3.45313C10.3667 3.42968 10.6333 3.42968 10.8984 3.45313L12.625 2.15625C13.2976 2.33692 13.9437 2.60481 14.5469 2.95312L14.8516 5.08594Z",
    stroke: "white",
    strokeWidth: 1.12028,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.ec92335aa0fd836abb43cb0783577d13.svg";
export { ForwardRef as ReactComponent };